import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {Environment} from '@/envs';
import {Envs, GlobalWindow} from '@/types';

export enum CookieNames {
  ProjectId = 'project_id',
}

interface CookieOptions {
  path?: string;
  domain?: string;
  maxAge?: number;
  expires?: number | Date;
  secure?: boolean;
  httpOnly?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
}

type CookieOptionsKeys = keyof CookieOptions;

export class CookiesService {
  constructor(
    private readonly globalWindow: GlobalWindow,
    private readonly envs: Envs,
  ) {}

  setCookie(name: CookieNames, value: string, options?: CookieOptions): void {
    let cookie = `${name}=${value}; `;

    cookie += this.getOptions(options);

    this.globalWindow.document.cookie = cookie;
  }

  getCookie(name: string): string {
    const cookies = this.globalWindow.document.cookie.split('; ');

    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=');

      if (cookieName === name) {
        return cookieValue;
      }
    }

    return '';
  }

  private getOptions(options?: CookieOptions): string {
    if (!options) {
      options = {};
    }

    const optionKeys = Object.keys(options) as CookieOptionsKeys[];

    if (optionKeys.length === 0) {
      return '';
    }

    const optionStrings = optionKeys.map((optionKey) => {
      const headerKey = this.convertCamelCaseToKebabCase(optionKey);
      const optionValue = options![optionKey];

      if (optionValue === true) {
        return headerKey;
      }

      if (optionValue instanceof Date) {
        return `${headerKey}=${optionValue.toUTCString()}`;
      }

      return `${headerKey}=${optionValue}`;
    });

    return optionStrings.join('; ');
  }

  private convertCamelCaseToKebabCase(optionKey: CookieOptionsKeys): string {
    // преобразовывает maxAge => max-age
    return optionKey.replace(/([A-Z])/g, '-$1').toLowerCase();
  }

  public getDomain(domain?: string): string {
    if (this.envs.APP_ENVIRONMENT === Environment.Local) {
      return '';
    }

    const defaultDomain = '.' + this.envs.APP_PROJECT_URL.split('.').slice(-2).join('.');

    return domain || defaultDomain;
  }
}

injected(CookiesService, DI_TOKENS.globalWindow, DI_TOKENS.envs);
